import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Team } from '../types';

const BlueJersey = styled('div')(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  backgroundColor: '#2450ff',
  display: 'inline-block',
  marginLeft: theme.spacing(1),
}));

const OrangeJersey = styled('div')(({ theme }) => ({
  width: theme.spacing(2),
  height: theme.spacing(2),
  backgroundColor: '#ef5e21',
  display: 'inline-block',
  marginLeft: theme.spacing(1),
}));

type TeamJerseyColorProps = {
  team: Team;
};

export default function TeamJerseyColor({
  team,
}: Readonly<TeamJerseyColorProps>) {
  switch (team.name) {
    case 'A':
      return (
        <Stack direction="row">
          <OrangeJersey />
          <OrangeJersey />
          <OrangeJersey />
        </Stack>
      );
    case 'B':
      return (
        <Stack direction="row">
          <BlueJersey />
          <BlueJersey />
          <BlueJersey />
        </Stack>
      );
    case 'C':
      return (
        <Stack direction="row">
          <BlueJersey />
          <BlueJersey />
          <OrangeJersey />
        </Stack>
      );
    case 'D':
      return (
        <Stack direction="row">
          <OrangeJersey />
          <OrangeJersey />
          <BlueJersey />
        </Stack>
      );
  }
}
